<div class="px-2 pt-2">
  <div *ngIf="doc">
    <div class="form-group">
      <div class="input-group input-group-sm">
        <div class="input-group-prepend"><span class="input-group-text">Autosave every</span></div>
        <select class="form-control" [(ngModel)]="autosaveInterval" [disabled]="disableAutosave">
          <option *ngFor="let interval of autosaveIntervals" [value]="interval">{{ interval }}</option>
        </select>
        <div class="input-group-append">
          <span class="input-group-text">minute{{ autosaveInterval != 1 ? 's' : '' }}</span>
        </div>
      </div>
      <div class="custom-control custom-checkbox mb-2 mr-sm-2 mb-sm-0" (click)="disableAutosave = !disableAutosave">
        <input type="checkbox" class="custom-control-input" [checked]="disableAutosave" [(ngModel)]="disableAutosave" />
        <label class="custom-control-label">Disable Autosave</label>
      </div>
    </div>
    <hr />
    <div class="mb-4">
      Devel Options
      <br />
      <button type="button" class="btn btn-sm btn-outline-secondary" (click)="previewInlineHtml()">Preview Inline HTML</button>
    </div>
    <div class="pl-3">
      <div>
        <div class="matter-sb-header" (click)="optionsExpand.letter_options = !optionsExpand.letter_options">
          <h5 class="font-weight-normal">
            <a style="font-size: 14px; padding-bottom: 4px" href="javascript: void(0)"><i [class]="'fa fa-' + (optionsExpand.letter_options ? 'minus' : 'plus') + '-circle'"></i></a>&nbsp;&nbsp;Letter Options
          </h5>
        </div>
        <div class="matter-sb-content pl-2 pt-2" [hidden]="!optionsExpand.letter_options">
          <div class="form-group">
            <div class="custom-control custom-checkbox mb-2 mr-sm-2 mb-sm-0" (click)="doc.attachments_included = !doc.attachments_included">
              <input type="checkbox" class="custom-control-input" [checked]="doc.attachments_included" [(ngModel)]="doc.attachments_included" />
              <label class="custom-control-label">Include attachments</label>
            </div>
          </div>
          <div class="form-group">
            <label>Signature</label>
            <select class="form-control" [(ngModel)]="doc.signature_matter_user_id">
              <option *ngFor="let signatureUser of signatureUsers" [value]="signatureUser.id">{{ signatureUser.label }}</option>
            </select>
          </div>
          <div class="form-group">
            <label>Salutation&nbsp;&nbsp;&nbsp;</label>
            <div class="custom-control custom-control-inline custom-radio mb-2 mr-sm-2 mb-sm-0" (click)="setFormal(true)">
              <input type="radio" name="is_formal" [checked]="doc.is_formal" class="custom-control-input" />
              <label class="custom-control-label">Formal</label>
            </div>
            <div class="custom-control custom-control-inline custom-radio mb-2 mr-sm-2 mb-sm-0" (click)="setFormal(false)">
              <input type="radio" name="is_formal" [checked]="!doc.is_formal" class="custom-control-input" />
              <label class="custom-control-label">Familiar</label>
            </div>
          </div>
          <div class="form-group">
            <label>To Contacts</label>
            <select class="form-control mb-2" #documentToContact (change)="fetchDocumentContact('To', documentToContact)">
              <option disabled="disabled" selected="selected" style="color: #5bc0de" value="no_selection">Involvement Contacts</option>
              <option *ngFor="let letterContact of letterContacts" [value]="letterContact.id">{{ letterContact.label }}</option>
            </select>
            <div  [appNativeSortableJs]="documentToContacts" [sortableOptions]="documentToSortOptions">
              <div class="card mt-1" *ngFor="let documentContact of documentToContacts; let i = index">
                <div class="card-header py-2 px-3" style="font-size: 90%">
                  <div class="d-flex justify-content-start">
                    <div class="align-self-center draggable-elem" style="cursor: grab"><i class="fas fa-random"></i></div>
                    <div (click)="documentContact.show_content = !documentContact.show_content" class="align-self-center mx-2" style="cursor: pointer"><i [class]="'fa fa-' + (documentContact.show_content ? 'minus' : 'plus') + '-circle'"></i></div>
                    <div class="align-self-center" [innerHTML]="documentContact.copy_of_contact | safeHtml"></div>
                    <div (click)="removeDocumentContact(documentToContacts, i)" class="ml-auto align-self-center ml-1" style="cursor: pointer"><i class="fas fa-times"></i></div>
                  </div>
                </div>
                <div class="card-block px-3 pt-1 pb-2" *ngIf="documentContact.show_content">
                  <div class="form-group mb-1" *ngIf="involvements[documentContact.involvement_id].addresses && involvements[documentContact.involvement_id].addresses.length > 0">
                    <label>Mail type</label>
                    <select class="form-control form-control-sm" [(ngModel)]="documentContact.mail_type">
                      <option *ngFor="let mailType of mailTypes" [value]="mailType">{{ mailType }}</option>
                    </select>
                  </div>
                  <div class="form-group mb-1" *ngIf="involvements[documentContact.involvement_id].addresses && involvements[documentContact.involvement_id].addresses.length > 0">
                    <label>Address</label>
                    <select class="form-control form-control-sm" [(ngModel)]="documentContact.address" (change)="setAddress(documentContact)">
                      <option *ngFor="let address of involvements[documentContact.involvement_id].addresses" [ngValue]="address">{{ address.full_address }}</option>
                    </select>
                  </div>
                  <div *ngIf="involvements[documentContact.involvement_id].addresses && involvements[documentContact.involvement_id].addresses.length > 0" style="font-size: 90%" class="pt-1 pl-4 mt-1 mb-1" [innerHTML]="sanitizeAddress(documentContact.copy_of_address || '')"></div>
                  <div class="form-check form-check-inline mb-1" *ngIf="involvements[documentContact.involvement_id].addresses && involvements[documentContact.involvement_id].addresses.length > 0">
                    <label class="form-check-label"> <input class="form-check-input" [(ngModel)]="documentContact.send_by_mail" type="checkbox" /> Send by Mail </label>
                  </div>
                  <hr class="my-1" *ngIf="involvements[documentContact.involvement_id].email_addresses && involvements[documentContact.involvement_id].email_addresses.length > 0" />
                  <div class="form-group mb-1" *ngIf="involvements[documentContact.involvement_id].email_addresses && involvements[documentContact.involvement_id].email_addresses.length > 0">
                    <label>Email</label>
                    <select [(ngModel)]="documentContact.email_address" (change)="setEmailAddress(documentContact)" class="form-control form-control-sm">
                      <option *ngFor="let email_address of involvements[documentContact.involvement_id].email_addresses" [ngValue]="email_address">{{ email_address.email }}</option>
                    </select>
                  </div>
                  <div class="form-check form-check-inline mb-1" *ngIf="involvements[documentContact.involvement_id].email_addresses && involvements[documentContact.involvement_id].email_addresses.length > 0">
                    <label class="form-check-label"> <input [(ngModel)]="documentContact.send_by_email" class="form-check-input" type="checkbox" /> Send by Email </label>
                  </div>
                  <hr class="my-1" *ngIf="documentContact.copy_of_fax" />
                  <div class="form-group mb-1" *ngIf="documentContact.copy_of_fax">
                    <label>Fax:&nbsp;{{ documentContact.copy_of_fax }}</label>
                  </div>
                  <div class="form-check form-check-inline mb-1" *ngIf="documentContact.copy_of_fax">
                    <label class="form-check-label"> <input [(ngModel)]="documentContact.send_by_fax" class="form-check-input" type="checkbox" /> Send by Fax </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="form-group">
            <label>CC Contacts</label>
            <select class="form-control" #documentCcContact (change)="fetchDocumentContact('CC', documentCcContact)">
              <option disabled="disabled" selected="selected" style="color: #5bc0de" value="no_selection">Involvement Contacts</option>
              <option *ngFor="let letterContact of letterContacts" [value]="letterContact.id">{{ letterContact.label }}</option>
            </select>
            <div  [appNativeSortableJs]="documentCcContacts" [sortableOptions]="documentCcSortOptions">
              <div class="card mt-1" *ngFor="let documentContact of documentCcContacts; let i = index">
                <div class="card-header py-2 px-3" style="font-size: 90%">
                  <div class="d-flex justify-content-start">
                    <div class="align-self-center draggable-elem" style="cursor: grab"><i class="fas fa-random"></i></div>
                    <div (click)="documentContact.show_content = !documentContact.show_content" class="align-self-center mx-2" style="cursor: pointer"><i [class]="'fa fa-' + (documentContact.show_content ? 'minus' : 'plus') + '-circle'"></i></div>
                    <div class="align-self-center" [innerHTML]="documentContact.copy_of_contact | safeHtml"></div>
                    <div (click)="removeDocumentContact(documentCcContacts, i)" class="ml-auto align-self-center ml-1" style="cursor: pointer"><i class="fas fa-times"></i></div>
                  </div>
                </div>
                <div class="card-block px-3 pt-1 pb-2" *ngIf="documentContact.show_content">
                  <div class="form-group mb-1" *ngIf="involvements[documentContact.involvement_id].addresses && involvements[documentContact.involvement_id].addresses.length > 0">
                    <label>Mail type</label>
                    <select class="form-control form-control-sm" [(ngModel)]="documentContact.mail_type">
                      <option *ngFor="let mailType of mailTypes" [value]="mailType">{{ mailType }}</option>
                    </select>
                  </div>
                  <div class="form-group mb-1" *ngIf="involvements[documentContact.involvement_id].addresses && involvements[documentContact.involvement_id].addresses.length > 0">
                    <label>Address</label>
                    <select class="form-control form-control-sm" [(ngModel)]="documentContact.address" (change)="setAddress(documentContact)">
                      <option *ngFor="let address of involvements[documentContact.involvement_id].addresses" [ngValue]="address">{{ address.full_address }}</option>
                    </select>
                  </div>
                  <div *ngIf="involvements[documentContact.involvement_id].addresses && involvements[documentContact.involvement_id].addresses.length > 0" style="font-size: 90%" class="pt-1 pl-4 mt-1 mb-1" [innerHTML]="sanitizeAddress(documentContact.copy_of_address || '')"></div>
                  <div class="form-check form-check-inline mb-1" *ngIf="involvements[documentContact.involvement_id].addresses && involvements[documentContact.involvement_id].addresses.length > 0">
                    <label class="form-check-label"> <input class="form-check-input" [(ngModel)]="documentContact.send_by_mail" type="checkbox" /> Send by Mail </label>
                  </div>
                  <hr class="my-1" *ngIf="involvements[documentContact.involvement_id].email_addresses && involvements[documentContact.involvement_id].email_addresses.length > 0" />
                  <div class="form-group mb-1" *ngIf="involvements[documentContact.involvement_id].email_addresses && involvements[documentContact.involvement_id].email_addresses.length > 0">
                    <label>Email</label>
                    <select [(ngModel)]="documentContact.email_address" (change)="setEmailAddress(documentContact)" class="form-control form-control-sm">
                      <option *ngFor="let email_address of involvements[documentContact.involvement_id].email_addresses" [ngValue]="email_address">{{ email_address.email }}</option>
                    </select>
                  </div>
                  <div class="form-check form-check-inline mb-1" *ngIf="involvements[documentContact.involvement_id].email_addresses && involvements[documentContact.involvement_id].email_addresses.length > 0">
                    <label class="form-check-label"> <input [(ngModel)]="documentContact.send_by_email" class="form-check-input" type="checkbox" /> Send by Email </label>
                  </div>
                  <hr class="my-1" *ngIf="documentContact.copy_of_fax" />
                  <div class="form-group mb-1" *ngIf="documentContact.copy_of_fax">
                    <label>Fax:&nbsp;{{ documentContact.copy_of_fax }}</label>
                  </div>
                  <div class="form-check form-check-inline mb-1" *ngIf="documentContact.copy_of_fax">
                    <label class="form-check-label"> <input [(ngModel)]="documentContact.send_by_fax" class="form-check-input" type="checkbox" /> Send by Fax </label>
                  </div>
                  <hr class="my-1" />
                  <div class="form-check form-check-inline mb-1">
                    <label class="form-check-label"> <input [(ngModel)]="documentContact.send_attachments" class="form-check-input" type="checkbox" /> Send Attachments </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="form-group">
            <label>BCC Contacts</label>
            <select class="form-control" #documentBccContact (change)="fetchDocumentContact('BCC', documentBccContact)">
              <option disabled="disabled" selected="selected" style="color: #5bc0de" value="no_selection">Involvement Contacts</option>
              <option *ngFor="let letterContact of letterContacts" [value]="letterContact.id">{{ letterContact.label }}</option>
            </select>
            <div>
              <div class="card mt-1" *ngFor="let documentContact of documentBccContacts; let i = index">
                <div class="card-header py-2 px-3" style="font-size: 90%">
                  <div class="d-flex justify-content-start">
                    <div class="align-self-center draggable-elem" style="opacity: 0"><i class="fas fa-random"></i></div>
                    <div (click)="documentContact.show_content = !documentContact.show_content" class="align-self-center mx-2" style="cursor: pointer"><i [class]="'fa fa-' + (documentContact.show_content ? 'minus' : 'plus') + '-circle'"></i></div>
                    <div class="align-self-center" [innerHTML]="documentContact.copy_of_contact | safeHtml"></div>
                    <div (click)="removeDocumentContact(documentBccContacts, i)" class="ml-auto align-self-center ml-1" style="cursor: pointer"><i class="fas fa-times"></i></div>
                  </div>
                </div>
                <div class="card-block px-3 pt-1 pb-2" *ngIf="documentContact.show_content">
                  <div class="form-group mb-1" *ngIf="involvements[documentContact.involvement_id].addresses && involvements[documentContact.involvement_id].addresses.length > 0">
                    <label>Mail type</label>
                    <select class="form-control form-control-sm" [(ngModel)]="documentContact.mail_type">
                      <option *ngFor="let mailType of mailTypes" [value]="mailType">{{ mailType }}</option>
                    </select>
                  </div>
                  <div class="form-group mb-1" *ngIf="involvements[documentContact.involvement_id].addresses && involvements[documentContact.involvement_id].addresses.length > 0">
                    <label>Address</label>
                    <select class="form-control form-control-sm" [(ngModel)]="documentContact.address" (change)="setAddress(documentContact)">
                      <option *ngFor="let address of involvements[documentContact.involvement_id].addresses" [ngValue]="address">{{ address.full_address }}</option>
                    </select>
                  </div>
                  <div *ngIf="involvements[documentContact.involvement_id].addresses && involvements[documentContact.involvement_id].addresses.length > 0" style="font-size: 90%" class="pt-1 pl-4 mt-1 mb-1" [innerHTML]="sanitizeAddress(documentContact.copy_of_address || '')"></div>
                  <div class="form-check form-check-inline mb-1" *ngIf="involvements[documentContact.involvement_id].addresses && involvements[documentContact.involvement_id].addresses.length > 0">
                    <label class="form-check-label"> <input class="form-check-input" [(ngModel)]="documentContact.send_by_mail" type="checkbox" /> Send by Mail </label>
                  </div>
                  <hr class="my-1" *ngIf="involvements[documentContact.involvement_id].email_addresses && involvements[documentContact.involvement_id].email_addresses.length > 0" />
                  <div class="form-group mb-1" *ngIf="involvements[documentContact.involvement_id].email_addresses && involvements[documentContact.involvement_id].email_addresses.length > 0">
                    <label>Email</label>
                    <select [(ngModel)]="documentContact.email_address" (change)="setEmailAddress(documentContact)" class="form-control form-control-sm">
                      <option *ngFor="let email_address of involvements[documentContact.involvement_id].email_addresses" [ngValue]="email_address">{{ email_address.email }}</option>
                    </select>
                  </div>
                  <div class="form-check form-check-inline mb-1" *ngIf="involvements[documentContact.involvement_id].email_addresses && involvements[documentContact.involvement_id].email_addresses.length > 0">
                    <label class="form-check-label"> <input [(ngModel)]="documentContact.send_by_email" class="form-check-input" type="checkbox" /> Send by Email </label>
                  </div>
                  <hr class="my-1" *ngIf="documentContact.copy_of_fax" />
                  <div class="form-group mb-1" *ngIf="documentContact.copy_of_fax">
                    <label>Fax:&nbsp;{{ documentContact.copy_of_fax }}</label>
                  </div>
                  <div class="form-check form-check-inline mb-1" *ngIf="documentContact.copy_of_fax">
                    <label class="form-check-label"> <input [(ngModel)]="documentContact.send_by_fax" class="form-check-input" type="checkbox" /> Send by Fax </label>
                  </div>
                  <hr class="my-1" />
                  <div class="form-check form-check-inline mb-1">
                    <label class="form-check-label"> <input [(ngModel)]="documentContact.send_attachments" class="form-check-input" type="checkbox" /> Send Attachments </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <div class="matter-sb-header" (click)="optionsExpand.document_info = !optionsExpand.document_info">
          <h5 class="font-weight-normal">
            <a style="font-size: 14px; padding-bottom: 4px" href="javascript: void(0)"><i [class]="'fa fa-' + (optionsExpand.document_info ? 'minus' : 'plus') + '-circle'"></i></a>&nbsp;&nbsp;Document Info
          </h5>
        </div>
        <div class="matter-sb-content pl-2 pt-2" [hidden]="!optionsExpand.document_info">
          <div class="form-group">
            <label>Name&nbsp;&nbsp;&nbsp;</label>
            <div (click)="useDefaultName = !useDefaultName; defaultNameChange()" class="custom-control custom-checkbox mb-2 mr-sm-2 mb-sm-0">
              <input type="checkbox" [checked]="useDefaultName" [(ngModel)]="useDefaultName" class="custom-control-input" />
              <label class="custom-control-label">Use default name</label>
            </div>
            <input type="text" class="form-control" [disabled]="useDefaultName" [(ngModel)]="doc.name" placeholder="Name" />
          </div>
          <div class="form-group">
            <label>Tags</label>
            <input type="text" class="form-control" [(ngModel)]="tagsList" placeholder="Tags (comma separated)" />
          </div>
          <div class="form-group">
            <label>Notes</label>
            <textarea class="form-control" [(ngModel)]="doc.notes" placeholder="Notes"></textarea>
          </div>
          <div class="form-group">
            <label>Extra History Note</label>
            <textarea class="form-control" [(ngModel)]="extraHistoryMessage" placeholder="History Note"></textarea>
          </div>
        </div>
      </div>
      <div>
        <div class="matter-sb-header" (click)="optionsExpand.margins = !optionsExpand.margins">
          <h5 class="font-weight-normal">
            <a style="font-size: 14px; padding-bottom: 4px" href="javascript: void(0)"><i [class]="'fa fa-' + (optionsExpand.margins ? 'minus' : 'plus') + '-circle'"></i></a>&nbsp;&nbsp;Margins
          </h5>
        </div>
        <div class="matter-sb-content pl-2 pt-2" [hidden]="!optionsExpand.margins">
          <div class="form-group">
            <div (click)="marginChange('simple')" class="custom-control custom-radio">
              <input [checked]="marginSettings.margin_selection == 'simple'" type="radio" name="margin_type" class="custom-control-input" />
              <label class="custom-control-label">Simple</label>
            </div>
            <div (click)="marginChange('advanced')" class="custom-control custom-radio">
              <input [checked]="marginSettings.margin_selection == 'advanced'" type="radio" name="margin_type" class="custom-control-input" />
              <label class="custom-control-label">Advanced</label>
            </div>
          </div>
          <div class="form-group" *ngIf="marginSettings.margin_selection == 'simple'">
            <label>Margins</label>
            <select class="form-control form-control-sm" [(ngModel)]="marginSettings.margin">
              <option *ngFor="let margin of marginOptions" [value]="margin">{{ margin }}</option>
            </select>
          </div>
          <div class="form-group" *ngIf="marginSettings.margin_selection == 'advanced'">
            <label>Margin Top</label>
            <select class="form-control form-control-sm" [(ngModel)]="marginSettings.margin_top">
              <option *ngFor="let margin of marginOptions" [value]="margin">{{ margin }}</option>
            </select>
          </div>
          <div class="form-group" *ngIf="marginSettings.margin_selection == 'advanced'">
            <label>Margin Right</label>
            <select class="form-control form-control-sm" [(ngModel)]="marginSettings.margin_right">
              <option *ngFor="let margin of marginOptions" [value]="margin">{{ margin }}</option>
            </select>
          </div>
          <div class="form-group" *ngIf="marginSettings.margin_selection == 'advanced'">
            <label>Margin Bottom</label>
            <select class="form-control form-control-sm" [(ngModel)]="marginSettings.margin_bottom">
              <option *ngFor="let margin of marginOptions" [value]="margin">{{ margin }}</option>
            </select>
          </div>
          <div class="form-group" *ngIf="marginSettings.margin_selection == 'advanced'">
            <label>Margin Left</label>
            <select class="form-control form-control-sm" [(ngModel)]="marginSettings.margin_left">
              <option *ngFor="let margin of marginOptions" [value]="margin">{{ margin }}</option>
            </select>
          </div>
        </div>
      </div>
      <div>
        <div class="matter-sb-header" (click)="optionsExpand.font_size = !optionsExpand.font_size">
          <h5 class="font-weight-normal">
            <a style="font-size: 14px; padding-bottom: 4px" href="javascript: void(0)"><i [class]="'fa fa-' + (optionsExpand.font_size ? 'minus' : 'plus') + '-circle'"></i></a>&nbsp;&nbsp;Font Size
          </h5>
        </div>
        <div class="matter-sb-content pl-2 pt-2" [hidden]="!optionsExpand.font_size">
          <div class="form-group">
            <div class="input-group input-group-sm">
              <select class="form-control" [(ngModel)]="fontSize">
                <option *ngFor="let fontSize of fontSizes" [value]="fontSize">{{ fontSize }}</option>
              </select>
              <div class="input-group-append"><span class="input-group-text">pt</span></div>
            </div>
          </div>
        </div>
      </div>
      <hr />
      <div class="mt-1 mb-3">
        <button (click)="previewDocument()" type="button" class="mx-1 mb-1 btn btn-outline-secondary" style="width: 150px" [disabled]="generatingPreview">
          <span *ngIf="generatingPreview"><i class="fas fa-spinner fa-spin"></i> Generating...</span>
          <span *ngIf="!generatingPreview">Preview</span>
        </button>
        <button (click)="previewDocument(true)" type="button" class="mx-1 mb-1 btn btn-outline-secondary" style="width: 150px" [disabled]="generatingPreview">
          <span *ngIf="generatingPreview"><i class="fas fa-spinner fa-spin"></i> Generating...</span>
          <span *ngIf="!generatingPreview">Preview Inline</span>
        </button>
        <button (click)="saveDocument()" type="button" *ngIf="doc.is_editable" class="mx-1 mb-1 btn btn-primary" style="width: 150px">Save</button>
        <button (click)="saveAndCloseDocument()" type="button" *ngIf="doc.is_editable" class="mx-1 mb-1 btn btn-success" style="width: 150px">Save &amp; Close</button>
        <button type="button" *ngIf="doc.is_editable && doc.is_letter" (click)="openOutgoingModal(outgoing_form_dialog)" class="mx-1 mb-1 btn btn-outline-secondary" style="width: 150px">Send</button>
        <button type="button" *ngIf="canSendMailMerge" class="mx-1 mb-1 btn btn-warning" style="width: 150px" (click)="saveDocument(false, false, true)">Send Mail Merge</button>
        <button type="button" class="mx-1 mb-1 btn btn-outline-secondary" style="width: 150px" (click)="newDocument()">New</button>
        <button type="button" (click)="cancelDocument()" class="mx-1 mb-1 btn btn-danger" style="width: 150px">Cancel</button>
      </div>
    </div>
  </div>
</div>
<ng-template #outgoing_form_dialog let-c="close" let-d="dismiss">
  <div class="modal-header">
    <h4 class="modal-title">New outgoing transaction</h4>
    <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <app-outgoing-form-dialog [matter_id]="matter_id" (result)="c($event)"></app-outgoing-form-dialog>
  </div>
</ng-template>
